import { type AppUsage, SITE_DOMAIN } from "@frontend/roz-sdk-core";

type NavigableSdk = {
  config: {
    _usage?: AppUsage;
  };
  // biome-ignore lint/suspicious/noExplicitAny: cross-instance compatibility (SDK + MockSdk)
  events: { emit: (...args: any[]) => void };
};

const isAbsoluteHref = (href: string) => href.startsWith("http");

export const isInternalSdkHref = (href: string) => {
  if (href.startsWith("/")) {
    return true;
  }

  if (typeof window === "undefined") {
    return false;
  }

  try {
    return (
      new URL(href, window.location.origin).origin === window.location.origin
    );
  } catch {
    return false;
  }
};

export const buildSdkHref = (
  href: string,
  usage: AppUsage = "external",
  customLink = false
) => {
  if (usage === "internal" || customLink || isAbsoluteHref(href)) {
    return href;
  }

  return `${SITE_DOMAIN}${href}`;
};

export const shouldOpenSdkHrefInNewTab = (
  href: string,
  usage: AppUsage = "external",
  customLink = false
) => usage !== "internal" && !customLink && !isAbsoluteHref(href);

export const navigateSdkHref = (sdk: NavigableSdk, href: string) => {
  const nextHref = buildSdkHref(href, sdk.config._usage);

  if (sdk.config._usage === "internal") {
    sdk.events.emit("navigate", nextHref);
    return;
  }

  window.location.assign(nextHref);
};
